function fireEvent(el, eventName, data)
{
   var event;

   if(document.createEvent){
        event = document.createEvent('HTMLEvents');
        event.initEvent(eventName,true,true);
    }

    event.eventName = eventName;
    event.customMessage = data;

    el.dispatchEvent(event);
}
